import * as React from 'react';

import { formatPrice } from '../../../shared/utils/format_helper';
import { waitForImage } from '../../../shared/utils/lazy_load_helper';
import { LazyLoad } from '../LazyLoad';
import { LinkArea } from '../LinkArea';
import { Address } from './Address';

import * as styles from './popular_item.css';

export interface IPopularItemProps {
  metro?: {
    timeType: string;
    name: string;
    lineColor: string;
    time: number;
  };
  title: string;
  url: string;
  priceAmount: number;
  price: {
    amount: number;
    priceType?: string;
  };
  address?: string;
  thumbnailUrl: string;
  onClick(): void;
}

export function PopularItem(props: IPopularItemProps) {
  const formattedPrice = formatPrice(props.price.amount, 4);

  return (
    <LinkArea href={props.url} className={`${styles['c-popular-block']} cg-col-8`} onClick={props.onClick}>
      <LazyLoad
        onLoad={() => waitForImage(props.thumbnailUrl)}
        renderEmpty={() => <div className={styles['c-popular-photo-wrap']} />}
        renderLoading={() => <div className={styles['c-popular-photo-wrap']} />}
        renderLoaded={() => (
          <div
            className={styles['c-popular-photo-wrap']}
            style={{
              backgroundImage: `url(${props.thumbnailUrl})`,
            }}
          />
        )}
        renderError={() => <div className={styles['c-popular-photo-wrap']}></div>}
      />
      <div className={styles['c-popular-info']}>
        <span className={styles['c-popular-price']}>{formattedPrice} ₽</span>
        <a
          href={props.url}
          className={styles['c-popular-tec-info']}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: props.title }}
        />
        <Address address={props.address} metro={props.metro} />
      </div>
    </LinkArea>
  );
}
